import { render, staticRenderFns } from "./DeptBarChart.vue?vue&type=template&id=4fe68d25&scoped=true"
import script from "./DeptBarChart.vue?vue&type=script&lang=js"
export * from "./DeptBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe68d25",
  null
  
)

export default component.exports